"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharePopover = exports.Menu = void 0;
var snakeCase_1 = __importDefault(require("lodash/snakeCase"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var react_transition_group_1 = require("react-transition-group");
var classnames_1 = __importDefault(require("classnames"));
var inversify_react_1 = require("inversify-react");
var withPolyfill_1 = __importDefault(require("react-resize-detector/build/withPolyfill"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var ShareSettingPanelHeader_1 = require("Common/ShareSettings/ShareSettingPanelHeader");
var PageStatusRow_1 = require("Project/PageStatusRow/PageStatusRow");
var Telemetry_1 = require("Common/Telemetry/Telemetry");
var UpsellerService_1 = __importDefault(require("Common/Upseller/UpsellerService"));
var SecuritySettings_1 = require("./Security/SecuritySettings");
var SharingSettings_1 = require("./OtherSettings/SharingSettings");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var ModalService_1 = __importDefault(require("@CommonFrontend/Modal/ModalService"));
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var RootDataStore_1 = require("DataStores/RootDataStore");
var LinkPreviewCard_1 = require("Common/LinkPreview/LinkPreviewCard");
var LinkPreviewSettings_1 = require("Share/LinkPreviewSettings/LinkPreviewSettings");
var LinkPreviewSettingsStore_1 = require("Share/LinkPreviewSettings/LinkPreviewSettingsStore");
var Utils_1 = require("@CommonFrontendBackend/Projects/Utils");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var Util_1 = require("@CommonFrontendBackend/Permissions/Util");
var Types_2 = require("@CommonFrontendBackend/Permissions/Types");
var AutoLinkExpiry_1 = require("./AutoLinkExpiry/AutoLinkExpiry");
var AutoLinkExpiryController_1 = require("./AutoLinkExpiry/AutoLinkExpiryController");
var AutoLinkExpirySelector_1 = require("./MenuSelectors/AutoLinkExpirySelector");
var AccessSettingsSelector_1 = require("./MenuSelectors/AccessSettingsSelector");
var OtherSettingsSelector_1 = require("./MenuSelectors/OtherSettingsSelector");
var NotifyUser_1 = __importStar(require("Common/NotifyUser/NotifyUser"));
var Telemetry_2 = require("Telemetry");
var ShouldDisableAcceptAndQuoteAccess_1 = __importDefault(require("Project/Service/ShouldDisableAcceptAndQuoteAccess"));
var ShareButton_1 = require("Project/ShareButton");
var PageStateChangeConfirmationModal_1 = require("Common/Modal/PageModals/PageStateChangeConfirmationModal");
var ShareOnSocials_1 = require("./ShareOnSocials/ShareOnSocials");
var ValidateStrings_1 = require("@CommonFrontendBackend/Utils/ValidateStrings");
var c = (0, BemBuilder_1.default)("share-popover");
var Menu;
(function (Menu) {
    Menu[Menu["Main"] = 0] = "Main";
    Menu[Menu["LinkPreview"] = 1] = "LinkPreview";
    Menu[Menu["Expiry"] = 2] = "Expiry";
    Menu[Menu["Access"] = 3] = "Access";
    Menu[Menu["OtherSettings"] = 4] = "OtherSettings";
})(Menu = exports.Menu || (exports.Menu = {}));
var SharePopover = (function (_super) {
    __extends(SharePopover, _super);
    function SharePopover(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.pageHeading = _this.props.projectStore.name;
        _this.handlePanelResize = function (width, height) {
            _this.panelHeight = height;
        };
        _this.handleTitleChange = function (newTitle) {
            _this.pageHeading = newTitle;
        };
        _this.confirmPageStatusChange = function (pageStatus) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, (0, PageStateChangeConfirmationModal_1.confirmStatusChangeWithModal)(pageStatus, this.modal, this.rootDataStore.userDataStore.useHistoryDataStore)];
            });
        }); };
        _this.activeMenu = (_a = props.initialMenu) !== null && _a !== void 0 ? _a : Menu.Main;
        _this.setToLiveReactionDisposer = (0, mobx_1.reaction)(function () { return _this.props.projectStore.status; }, function () { return _this.handleSetStatusToLive(); });
        return _this;
    }
    SharePopover.prototype.handleSetStatusToLive = function () {
        if (this.props.projectStore.status !== Types_1.ProjectStatus.Live)
            return;
        (0, kaleidoscope_1.copyToClipboard)(this.shareableLinkUrl);
        this.notifyUser.success("Shareable link copied", undefined, NotifyUser_1.NOTIFICATION_POSITION.Left);
    };
    Object.defineProperty(SharePopover.prototype, "linkPreviewSettingsStore", {
        get: function () {
            return new LinkPreviewSettingsStore_1.LinkPreviewSettingsStore(this.props.projectStore, this.account);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharePopover.prototype, "autoLinkExpiryController", {
        get: function () {
            return new AutoLinkExpiryController_1.AutoLinkExpiryController(this.props.projectStore);
        },
        enumerable: false,
        configurable: true
    });
    SharePopover.prototype.selectMenu = function (subMenu) {
        this.activeMenu = subMenu;
    };
    SharePopover.prototype.backToMainMenu = function () {
        this.activeMenu = Menu.Main;
    };
    Object.defineProperty(SharePopover.prototype, "hasEditPermission", {
        get: function () {
            return (0, Util_1.isAtLeast)(this.props.projectStore.userAction, Types_2.Action.Edit);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharePopover.prototype, "isProjectEditable", {
        get: function () {
            return (0, Utils_1.isActionAllowed)(this.props.projectStore.status, Types_1.ProjectActions.Edit) && this.hasEditPermission;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharePopover.prototype, "areSettingsEditable", {
        get: function () {
            return this.hasEditPermission && !(0, Types_1.isPageLocked)(this.props.projectStore.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharePopover.prototype, "isSharingDisabled", {
        get: function () {
            var _a = this.props, usingFeature = _a.usingFeature, projectStore = _a.projectStore;
            var shouldDisableAcceptAndQuoteAccessFn = (0, ShouldDisableAcceptAndQuoteAccess_1.default)(usingFeature);
            var isPublicViewable = (0, Utils_1.isActionAllowed)(projectStore.status, Types_1.ProjectActions.PublicPageView);
            return !isPublicViewable || shouldDisableAcceptAndQuoteAccessFn(projectStore);
        },
        enumerable: false,
        configurable: true
    });
    SharePopover.prototype.getMenuClickHandler = function (menu) {
        var _this = this;
        return this.isProjectEditable ? function () { return _this.selectMenu(menu); } : undefined;
    };
    SharePopover.prototype.canAccessBasicSecurity = function () {
        var _a = this.props, usingFeature = _a.usingFeature, projectStore = _a.projectStore;
        return (usingFeature(FeatureFlag_1.default.Security) ||
            this.projectSecurer.getEnabledSecurityMeasures(projectStore.links[0]).length > 0);
    };
    Object.defineProperty(SharePopover.prototype, "shareableLinkUrl", {
        get: function () {
            var links = this.projectLinkRetriever.getAllUrlsForProject(this.props.projectStore);
            return links.customDomain || links.subdomain || links.primaryDomain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharePopover.prototype, "expiryMenuSelector", {
        get: function () {
            var projectStore = this.props.projectStore;
            var _a = this.autoLinkExpiryController, daysUntilExpiry = _a.daysUntilExpiry, expiryDate = _a.expiryDate, enabled = _a.enabled;
            return (react_1.default.createElement(AutoLinkExpirySelector_1.AutoLinkExpiryMenuSelector, { onClick: this.getMenuClickHandler(Menu.Expiry), projectStatus: projectStore.status, subStatus: projectStore.subStatus, expiryEnabled: enabled, daysUntilExpiry: daysUntilExpiry, expiryDate: expiryDate, disabled: !this.isProjectEditable }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharePopover.prototype, "accessMenuSelector", {
        get: function () {
            var usingFeature = this.props.usingFeature;
            var _a = this.props.projectStore.linkStore, identityMappingStore = _a.identityMappingStore, isPasswordProtected = _a.isPasswordProtected, hasPassword = _a.hasPassword;
            return (react_1.default.createElement(AccessSettingsSelector_1.AccessSettingsMenuSelector, { onClick: this.getMenuClickHandler(Menu.Access), identityMappingStore: identityMappingStore, isPasswordProtected: isPasswordProtected, hasPassword: hasPassword, disabled: !this.isProjectEditable, refreshedIdentityProtected: usingFeature(FeatureFlag_1.default.RefreshedIdentityProtected) }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharePopover.prototype, "otherSettingsSelector", {
        get: function () {
            var projectStore = this.props.projectStore;
            return (react_1.default.createElement(OtherSettingsSelector_1.OtherSettingsMenuSelector, { onClick: this.getMenuClickHandler(Menu.OtherSettings), ipFilterStore: projectStore.linkStore.ipFilterStore, allowIndexing: projectStore.allowIndexing, enableSocialBadge: projectStore.enableSocialBadge, viewLimit: projectStore.linkStore.viewLimit, disabled: !this.isProjectEditable, projectSettings: projectStore.settings, usingFeature: this.props.usingFeature }));
        },
        enumerable: false,
        configurable: true
    });
    SharePopover.prototype.onSharableLinkCopied = function () {
        var _a;
        this.telemetry.track(Telemetry_2.TelemetryEventName.PublicLinkCopied, (_a = {},
            _a["".concat((0, snakeCase_1.default)(Telemetry_2.TelemetryEventName.PublicLinkCopied), "_source")] = TelemetryEnums_1.TelemetrySource.Editor,
            _a), { blockIntercom: true, blockIdentify: true, includeAuthAttrs: true });
    };
    SharePopover.prototype.componentDidMount = function () {
        var _a;
        this.telemetry.track(Telemetry_2.TelemetryEventName.ProjectShareViewed, (_a = {},
            _a[Telemetry_2.ProjectShareViewedFields.Origin] = this.props.source,
            _a[Telemetry_2.ProjectShareViewedFields.Version] = 2,
            _a), { blockIntercom: true, blockIdentify: true });
    };
    SharePopover.prototype.componentWillUnmount = function () {
        this.setToLiveReactionDisposer();
    };
    SharePopover.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, gotoPage = _b.gotoPage, projectStore = _b.projectStore, mobileLayout = _b.mobileLayout;
        var isTemplate = projectStore.isTemplate, name = projectStore.name;
        return (react_1.default.createElement("div", { className: c("popover-content"), style: { height: this.panelHeight } },
            react_1.default.createElement(react_transition_group_1.TransitionGroup, { component: null },
                this.activeMenu === Menu.Main && (react_1.default.createElement(MenuTransition, { onResize: this.handlePanelResize },
                    !mobileLayout && (react_1.default.createElement(kaleidoscope_1.TextInput, { variant: kaleidoscope_1.TextInputVariant.Underlined, size: kaleidoscope_1.TextInputSize.Small, endElement: react_1.default.createElement(icons_1.Edit, null), label: "editable-heading", placeholder: "Untitled", value: this.pageHeading, disabled: !this.areSettingsEditable, onChange: function (newHeading) { return _this.handleTitleChange(newHeading); }, onBlur: function () {
                            document.title = _this.pageHeading;
                            projectStore.updateName(_this.pageHeading);
                        }, className: "space-stack-m", error: this.projectNameError })),
                    react_1.default.createElement("div", { className: c("link-preview-card") },
                        react_1.default.createElement(LinkPreviewCard_1.LinkPreviewCard, { clickable: this.areSettingsEditable, imageUrl: this.linkPreviewSettingsStore.previewImageUrl, handleOnClick: function () { return _this.selectMenu(Menu.LinkPreview); } })),
                    !isTemplate && (react_1.default.createElement(PageStatusRow_1.PageStatusRow, { status: projectStore.status, hideStatus: false, projectValue: (_a = this.props.pageQuoteTotalStore) === null || _a === void 0 ? void 0 : _a.formattedPageValue, hasTemplateChildren: projectStore.hasTemplateChildren, setStatus: projectStore.setStatus, disabled: !this.hasEditPermission, projectId: projectStore._id, gotoPage: gotoPage, disableManualAcceptance: projectStore.quoteBlockCount > 0 || projectStore.hasAcceptEnabled, confirmPageStatusChange: this.confirmPageStatusChange, settableStatuses: PageStatusRow_1.SettableStatuses.All })),
                    this.expiryMenuSelector,
                    this.accessMenuSelector,
                    this.otherSettingsSelector,
                    !isTemplate && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: c("share-on-socials-container") },
                            react_1.default.createElement(ShareOnSocials_1.ShareOnSocials, { projectName: name, linkUrl: this.shareableLinkUrl })),
                        react_1.default.createElement(ShareButton_1.ShareButton, { disabled: this.isSharingDisabled, linkUrl: this.shareableLinkUrl, telemetryCallback: function () { return _this.onSharableLinkCopied(); } }))))),
                this.renderSubMenu())));
    };
    Object.defineProperty(SharePopover.prototype, "projectNameError", {
        get: function () {
            var htmlCheck = (0, ValidateStrings_1.checkPageName)(this.pageHeading);
            if (htmlCheck.valid === false) {
                return "Page name ".concat(htmlCheck.error);
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    SharePopover.prototype.renderSubMenu = function () {
        var _a = this.props, projectStore = _a.projectStore, usingFeature = _a.usingFeature, mobileLayout = _a.mobileLayout, onDefaultLinkPreviewClick = _a.onDefaultLinkPreviewClick;
        switch (this.activeMenu) {
            case Menu.LinkPreview:
                return (react_1.default.createElement(MenuTransition, { isSecondary: true, onResize: this.handlePanelResize },
                    react_1.default.createElement(ShareSettingPanelHeader_1.ShareSettingPanelHeader, { settingTitle: "Image preview settings", handleSettingSelect: this.backToMainMenu }),
                    react_1.default.createElement(LinkPreviewSettings_1.LinkPreviewSettings, { canEdit: this.areSettingsEditable, linkPreviewSettingsStore: this.linkPreviewSettingsStore, projectId: projectStore._id, usingFeature: usingFeature, mobileLayout: mobileLayout, defaultSettingsOnClick: onDefaultLinkPreviewClick })));
            case Menu.Expiry:
                return (react_1.default.createElement(MenuTransition, { isSecondary: true, onResize: this.handlePanelResize },
                    react_1.default.createElement(ShareSettingPanelHeader_1.ShareSettingPanelHeader, { settingTitle: "Link expiry settings", helpTooltipContent: AutoLinkExpiry_1.HELP_PROMPT_STRING, handleSettingSelect: this.backToMainMenu }),
                    react_1.default.createElement(AutoLinkExpiry_1.AutoLinkExpirySettings, { autoLinkExpiryController: this.autoLinkExpiryController })));
            case Menu.Access:
                return (react_1.default.createElement(MenuTransition, { isSecondary: true, onResize: this.handlePanelResize },
                    react_1.default.createElement(ShareSettingPanelHeader_1.ShareSettingPanelHeader, { settingTitle: "Access settings", handleSettingSelect: this.backToMainMenu }),
                    react_1.default.createElement(SecuritySettings_1.SecuritySettings, { telemetry: this.telemetry, projectStore: projectStore, canUsePasswordProtect: this.canAccessBasicSecurity(), canUseIdentityMapping: this.props.usingFeature(FeatureFlag_1.default.IdentityMapping), getUpsellMessage: this.upsellerService.getTooltipUpsellMessage })));
            case Menu.OtherSettings:
                return (react_1.default.createElement(MenuTransition, { isSecondary: true, onResize: this.handlePanelResize },
                    react_1.default.createElement(ShareSettingPanelHeader_1.ShareSettingPanelHeader, { settingTitle: "Other settings", handleSettingSelect: this.backToMainMenu }),
                    react_1.default.createElement(SharingSettings_1.SharingSettings, { telemetry: this.telemetry, projectStore: projectStore, projectSharer: this.projectSharer, officeIpAddresses: this.account.settings.officeIpAddresses, usingFeature: usingFeature, getUpsellMessage: this.upsellerService.getTooltipUpsellMessage })));
        }
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], SharePopover.prototype, "pageHeading", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], SharePopover.prototype, "panelHeight", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], SharePopover.prototype, "activeMenu", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof mobx_1.IReactionDisposer !== "undefined" && mobx_1.IReactionDisposer) === "function" ? _a : Object)
    ], SharePopover.prototype, "setToLiveReactionDisposer", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("projectLinkRetriever"),
        __metadata("design:type", Object)
    ], SharePopover.prototype, "projectLinkRetriever", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("telemetry"),
        __metadata("design:type", typeof (_b = typeof Telemetry_1.Telemetry !== "undefined" && Telemetry_1.Telemetry) === "function" ? _b : Object)
    ], SharePopover.prototype, "telemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("modal"),
        __metadata("design:type", typeof (_c = typeof ModalService_1.default !== "undefined" && ModalService_1.default) === "function" ? _c : Object)
    ], SharePopover.prototype, "modal", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("rootDataStore"),
        __metadata("design:type", typeof (_d = typeof RootDataStore_1.RootDataStore !== "undefined" && RootDataStore_1.RootDataStore) === "function" ? _d : Object)
    ], SharePopover.prototype, "rootDataStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("projectSecurer"),
        __metadata("design:type", Object)
    ], SharePopover.prototype, "projectSecurer", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("projectSharer"),
        __metadata("design:type", Object)
    ], SharePopover.prototype, "projectSharer", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("upsellerService"),
        __metadata("design:type", typeof (_e = typeof UpsellerService_1.default !== "undefined" && UpsellerService_1.default) === "function" ? _e : Object)
    ], SharePopover.prototype, "upsellerService", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("account"),
        __metadata("design:type", Object)
    ], SharePopover.prototype, "account", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("notifyUser"),
        __metadata("design:type", typeof (_f = typeof NotifyUser_1.default !== "undefined" && NotifyUser_1.default) === "function" ? _f : Object)
    ], SharePopover.prototype, "notifyUser", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_g = typeof LinkPreviewSettingsStore_1.LinkPreviewSettingsStore !== "undefined" && LinkPreviewSettingsStore_1.LinkPreviewSettingsStore) === "function" ? _g : Object),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "linkPreviewSettingsStore", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_h = typeof AutoLinkExpiryController_1.AutoLinkExpiryController !== "undefined" && AutoLinkExpiryController_1.AutoLinkExpiryController) === "function" ? _h : Object),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "autoLinkExpiryController", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SharePopover.prototype, "handlePanelResize", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SharePopover.prototype, "selectMenu", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SharePopover.prototype, "backToMainMenu", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SharePopover.prototype, "handleTitleChange", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "hasEditPermission", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "isProjectEditable", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "areSettingsEditable", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "isSharingDisabled", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "shareableLinkUrl", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_j = typeof JSX !== "undefined" && JSX.Element) === "function" ? _j : Object),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "expiryMenuSelector", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_k = typeof JSX !== "undefined" && JSX.Element) === "function" ? _k : Object),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "accessMenuSelector", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_l = typeof JSX !== "undefined" && JSX.Element) === "function" ? _l : Object),
        __metadata("design:paramtypes", [])
    ], SharePopover.prototype, "otherSettingsSelector", null);
    SharePopover = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SharePopover);
    return SharePopover;
}(react_1.default.Component));
exports.SharePopover = SharePopover;
function MenuTransition(_a) {
    var children = _a.children, onResize = _a.onResize, isSecondary = _a.isSecondary, invisibleProps = __rest(_a, ["children", "onResize", "isSecondary"]);
    return (react_1.default.createElement(react_transition_group_1.Transition, __assign({}, invisibleProps, { timeout: kaleidoscope_2.AnimationDuration.Long, onEnter: function (node) {
            (0, utils_1.forceReflow)(node);
        } }), function (status) {
        var _a;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(withPolyfill_1.default, { handleHeight: true, onResize: onResize }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)((_a = {}, _a[c("popover-panel", "secondary")] = isSecondary, _a), [
                    c("popover-panel"),
                    c("popover-panel", status),
                ]) }, children)));
    }));
}
